/**
 * scheme Planning actions constants.
 * URL in these constants are having dynamic variables
 * wrapped in {}, replace them with original dynamic variables
 * in order to send API requests.
 */

export const SCHEDULE_LIST_URL =
  "/scheme-planning/ims/schemeplanlist?pageNo={currentPage}&pageSize={pageSize}&sortBy={value}{sortOrder}";
export const GET_GENERAL_DATA_DETAILS = "/scheme-planning/ims/{planId}";
export const GENERAL_MASTER_DATA_URI = "/scheme-planning/ims/masterdata{payload}";
export const MASTER_DATA_URI = "/scheme-planning/ims/masterdata";
export const PRODUCT_GROUPS_URL = "/scheme-planning/ims/productgroups"; // url for multiple product group data
export const PARTNER_GROUPS_URL = "/scheme-planning/ims/partnergroups/?pageNo={currentPage}&pageSize={pageSize}&sortBy={value}{sortOrder}"; // url for multiple partner group data
export const PRODUCT_ALL_GROUP_URL =
  "/scheme-planning/ims/productgroup/allgroups/?pageNo={currentPage}&pageSize={pageSize}&sortBy={value}{sortOrder}";
export const SMART_SEARCH_PARTNER_GROUP_URL = 
"/scheme-planning/ims/partner/groups/search?value={search}";
export const SMART_SEARCH_PRODUCT_GROUP_URL = 
"/scheme-planning/ims/productgroup/search?value={search}";
export const PRODUCT_LISTING_URL =
  "/scheme-planning/ims/productgroup/allgroup/{planId}";
export const PARTNER_GROUP_URL = "/scheme-planning/ims/partnergroup/masterdata"; // url for single partner group data
export const FETCH_SINGLE_GROUP_URL =
  "/scheme-planning/ims/partnergroup/{payload}";
export const FETCH_VIEWPRODUCT_HEIRACHY_URL =
  "/scheme-planning/ims/productgroup/{payload}";
export const PARTNER_GROUP_BY_TYPE_URL =
  "/scheme-planning/ims/partnergroup/type/{payload}";
export const SAVE_NEW_PARTNER_URL = "/scheme-planning/ims/save/partnergroup";
export const ADD_NEW_PRODUCT_GROUP_URL =
  "/scheme-planning/ims/productgroup/add";
export const UPDATE_PARTNER_URL = "/scheme-planning/ims/upload/partner";
export const VALIDATE_PARTNER_CODE_URL =
  "/scheme-planning/ims/partnergroup/partnercode/{partnerCode}/{type}/{divisionCode}";
export const VALIDATE_PARTNER_EXCLUDE_INCLUDE_CODE_URL =
  "/scheme-planning/ims/partnergroup/partnercode/{partnerCode}/{type}/{divisionCode}?{queryString}";
export const VALIDATE_PRODUCT_EXCLUDE_INCLUDE_CODE_URL =
  "/scheme-planning/ims/productgroup/validate/productCode?productCode={productCode}&{queryString}";
export const VALIDATE_TARGET_PARTNER_CODE_URL =
  "/scheme-planning/ims/target/validate/partnerCode?partnerCode={partnerCode}&targetNo={targetNo}";
export const VALIDATE_PRODUCT_CODE_URL =
  "/scheme-planning/ims/productgroup/validate/productCode?productCode={productCode}";
export const SAVE_UPDATED_PRODUCT_GROUP_URL =
  "/scheme-planning/ims/productgroup/productcodes/add";
export const PRODUCT_GROUP_DATA_UPDATE_URL =
  "/scheme-planning/ims/productgroup/upload/product";
export const PRODUCT_GROUP_MASTER_URL =
  "/scheme-planning/ims/productgroup/master";
export const PRODUCT_GROUP_LEVELS_URL =
  "/scheme-planning/ims/productgroup/levels";
export const PRODUCT_ATTRIBUTE_TYPE_URL =
  "/scheme-planning/ims/productgroup/attribute/{payload}?productOrgDimKey={productOrgDimKey}&levelNumber={levelNumber}";
export const PRODUCT_ATTRIBUTE_LIST_URL =
  "/scheme-planning/ims/productgroup/productAttribute?productOrgDimKey={productOrgDimKey}&levelNumber={levelNumber}&name={name}";
export const ADD_GENERAL_DATA_URL = "/scheme-planning/ims/add";
export const EDIT_GENERAL_DATA_URL = "/scheme-planning/ims/editPlan";
export const UPDATED_SCHEMA_STATUS_URL = "/scheme-planning/ims/status/edit";
export const SELECTED_PARTNER_GROUP_URL =
  "/scheme-planning/ims/partnergroup/partnercodes?{queryString}";
export const SELECTED_PRODUCT_GROUP_URL =
  "/scheme-planning/ims/productgroup/productcodes?{queryString}";
export const UPLOAD_PARTNER_VIA_EXCEL_URL =
  "/scheme-planning/ims/upload/partner";
export const UPLOAD_PRODUCT_VIA_EXCEL_URL =
  "/scheme-planning/ims/productgroup/upload/product";
export const DELETE_PARTNER_GROUP_URL =
  "/scheme-planning/ims/partnergroup/delete";
export const DELETE_PRODUCT_GROUP_URL =
  "/scheme-planning/ims/productgroup/delete";
export const SAVE_PARTNER_AS_DRAFT_URL = "/scheme-planning/ims/save/partners";
export const PRODUCT_ASSOCIATION_DATA_URL =
  "/scheme-planning/ims/productgroup/link";
export const PARTNER_ASSOCIATION_DATA_URL =
  "/scheme-planning/ims/partnergroup/planassociation";
  export const DOWNLOAD_PARTNER_DEALER_DETAIL_URL =
  "/scheme-planning/ims/download/downloadPartnerGroupAllDataIncludedExcluded?planNumber={planNumber}&partnerGroupNumber={partnerGroupNumber}&exportPayoutOn={exportPayoutOn}";
export const PARTNERGROUP_ASSOCIATION_URL =
  "/scheme-planning/ims/partnergroups/plan/association/{planId}";
export const DELETE_PARTNER_PLAN_ASSOCIATION_URL =
  "/scheme-planning/ims/delete/planassociation?partnerGroupId={partnerGroupId}&planId={planId}";
export const DELETE_PRODUCT_GROUP_ASSOCIATION_URL =
  "/scheme-planning/ims/productgroup/delete/planassociation?planId={planId}&groupId={groupId}";
export const SAVE_SCHEMA_PROGRAM_URL =
  "/scheme-planning/ims/save/schemeprogram";
export const PROGRAM_LISTING_DATA_URL =
  "/scheme-planning/ims/schemeprograms/{payload}";
export const PROGRAM_MASTER_DATA_URL = "/scheme-planning/ims/schemeprogram";
export const DELETE_PROGRAM_URL = "/scheme-planning/ims/delete";
export const COPY_PROGRAM_URL =
  "/scheme-planning/ims/copyprogram?programNo={programNo}";
export const UPDATE_SCHEMA_PROGRAM_URL =
  "/scheme-planning/ims/update/schemeprogram";
export const ELIGIBILITY_MASTER_URL =
  "/scheme-planning/ims/eligibility/master?programNo={programNo}";
export const TARGET_MASTER_URL =
  "/scheme-planning/ims/target/master?programNo={programNo}";
export const SYSTEM_TARGET_LISTING_URL =
  "/scheme-planning/ims/target/alltargets?programId={programId}";
export const SAVE_TARGET_SYSTEM_URL = "/scheme-planning/ims/target/add";
export const DELETE_SYSTEM_TARGET_URL =
  "/scheme-planning/ims/target/{prgId}/delete"; // replace <prgId> with dynamic data.
export const MANUAL_TARGET_LISTING_URL =
  "/scheme-planning/ims/target/getProgramTargetManualList?programNumber={programNumber}";
export const TARGET_LINK_DATA_URL =
  "/scheme-planning/ims/target/targets/combined/{programNo}"; // replace programNo with dynamic value.
export const SAVE_MANUAL_TARGET_URL =
  "/scheme-planning/ims/target/addProgramTargetManual?programNumber={programNumber}"; // replace <prgramNumber> with dynamic value
export const UPDATE_TARGET_URL = "/scheme-planning/ims/target/update";
export const DELETE_MANUAL_TARGET_URL =
  "/scheme-planning/ims/target/removeProgramTargetManualList";
export const VALIDATE_LINK_DATA_URL =
  "/scheme-planning/ims/target/validations/{planNo}"; // replace planNo with dynamic data
export const ADD_ELIGIBILITY_URL = "/scheme-planning/ims/eligibility/add";
export const UPDATE_ELIGIBILITY_URL = "/scheme-planning/ims/eligibility/update";
export const SAVE_TARGET_EXCEPTION_URL =
  "/scheme-planning/ims/target/save/finalTargets?targetNo={id}"; // replace id with dynamic id.
export const UPLOAD_TARGET_EXCEPTION_URL =
  "/scheme-planning/ims/target/upload/target/{targetNo}";
export const PAYOUT_LISTING_URL =
  "/scheme-planning/ims/payout/allpayout?programNo={payload}";
export const CALCULATE_TARGET = "/scheme-planning/ims/target/calculateTarget";
export const PAYOUT_MASTER_DATA_URL =
  "/scheme-planning/ims/payout/master?programNo={programNo}";
export const PAYOUT_SAVE_URL =
  "/scheme-planning/ims/payout/save?programNo={prgId}";
export const PAYOUT_SAVE_CSV_URL =
  "/scheme-planning/ims/payout/import/excel/{payoutId}";
export const PAYOUT_BULK_SAVE_CSV_URL =
  "/scheme-planning/ims/payout/bulk-import/excel?schemeProgramHdrId={programNo}";
export const EDIT_PAYOUT_URL = "/scheme-planning/ims/payout/validations/save";
export const DELETE_PAYOUT_URL =
  "/scheme-planning/ims/payout/{programNo}/delete";
export const CONDITION_ELIGIBILITY_URL =
  "/scheme-planning/ims/eligibility/viewall?programNo={programNo}";
export const DELETE_CONDITION_ELIGIBILITY_URL =
  "/scheme-planning/ims/eligibility/{programNo}/delete";
export const PROGRAM_TC_URL =
  "/scheme-planning/ims/schemeProgramTermAndCondition?programId={programId}";
export const VIEW_TEMPLATE_DATA_URL =
  "/scheme-planning/ims/payout/viewTempalte?programNo={id}";
export const PARAMETER_OPTIONS_URL =
  "/scheme-planning/ims/getAdditionalParameter";
export const SAVE_VALIDATION_DATA_URL =
  "/scheme-planning/ims/saveValidation?planNumber={planNumber}";
export const DELETE_VALIDATION_URL =
  "/scheme-planning/ims/?validationNumber={payload}";
export const VALIDATION_LIST_URL =
  "/scheme-planning/ims/validationList?planNumber={payload}";
export const SAVE_SCHEME_TERM_CONDITION_URL =
  "/scheme-planning/ims/schemePlanTermAndCondition?planNumber={planNumber}";
export const COPY_SCHEME_PLAN = "/scheme-planning/ims/copy";
export const REVISE_SCHEME_PLAN =
  "/scheme-planning/ims/revision?revisionId={revisionId}&date={date}";
  export const REVISE_PAYOUT_URL =
  "/scheme-planning/ims/payout/revision?revisionId={revisionId}";

export const SAVE_PAYOUT_SLAB_URL =
  "/scheme-planning/ims/payout/save/slab?payoutId={payoutId}&eligibilityId={eligibilityId}";
export const PARTNER_MASTER_GEO_ELEMENT =
  "/scheme-planning/ims/partnergroup/masterdata/geo?division={division}&{channelIds}";
export const PARTNER_MASTER_GEO_LEVEL =
  "/scheme-planning/ims/partnergroup/masterdata/geo?division={division}&{channelIds}&{levelId}";
export const PAYOUT_EXCEL_URL =
  "/scheme-planning/ims/payout/export/template?payoutNo={payoutNo}";
  export const PAYOUT_BULK_EXCEL_URL =
  "/scheme-planning/ims/payout/bulk-export/template?schemeProgramHdrId={schemeProgramHdrId}";
export const PREFILL_EXCEL_URL =
  "/scheme-planning/ims/payout/prefill/download?payoutId={payoutId}";
export const TARGET_EXCEPTION_URL =
  "/scheme-planning/ims/target/download/targettemplate/{payload}";
export const UPDATED_DOWNLOAD_PARTNER_URL =
  "/scheme-planning/ims/download/partnertemplate";
export const EXCLUDE_DOWNLOAD_PARTNER_URL =
  "/scheme-planning/ims/download/partnertemplatewithdata?planNumber={planNumber}&partnerGroupNumber={partnerGroupNumber}";
export const UPDATED_DOWNLOAD_PRODUCT_URL =
  "/scheme-planning/ims/productgroup/download/producttemplate";
export const EXCLUDE_DOWNLOAD_PRODUCT_URL =
  "/scheme-planning/ims/productgroup/download/producttemplateWithData?planNumber={planNumber}&productGroupNumber={productGroupNumber}";
export const SOLD_TO_PARTNER_URL =
  "/scheme-planning/ims/download/partnertemplate";
export const SPECIFIC_PARTNER_EXCEL_URL =
  "/scheme-planning/ims/download/partnertemplate";
export const SPECIFIC_PRODUCT_EXCEL_URL =
  "/scheme-planning/ims/productgroup/download/producttemplate";
export const TNC_HEADER_FOOTER_OPTIONS_URL =
  "/scheme-planning/ims/headerfooter?division={division}&incentiveAudience={incentiveAudience}";
export const TNC_HEADER_FOOTER_BY_ID_URL =
  "/scheme-planning/ims/headerfooter/{id}";
export const PARTNER_ATTRIBUTE_VALUE =
  "/scheme-planning/ims/partnergroup/attribute/value?{payload}";
export const DELETE_SCHEME_PLAN_URL =
  "/scheme-planning/ims/plan/delete?planNo={planNo}";
export const UPDATED_EXCLUDED_PARTNER_GROUP_URL =
  "/scheme-planning/ims/partnergroup/includeExclude?{queryString}";
export const UPDATED_EXCLUDED_PRODUCT_GROUP_URL =
  "/scheme-planning/ims/productgroup/included/excluded?{queryString}";
export const VIEW_TARGET_LIST_URL =
  "/scheme-planning/ims/target/{targetNo}?pageNo={currentPage}&pageSize={pageSize}";
export const TARGET_EXCEPTION_LIST_URL =
  "/scheme-planning/ims/target/exception?schemeplantargetexcdeptionid={schemeplantargetexcdeptionid}&pageNo={currentPage}&pageSize={pageSize}";
export const UPLOAD_PAYOUT_PREFILL_URL =
  "/scheme-planning/ims/payout/Prefill/upload?payoutId={payoutId}";
export const PREFILL_SAVE_URL =
  "/scheme-planning/ims/payout/prefill/save?payoutId={payoutId}";
export const PREFILL_PRODUCT_LIST_URL =
  "/scheme-planning/ims/payout/prefill/productList?payoutId={payoutId}";

export const PARTNER_TYPE_LIST =
  "/scheme-planning/ims/getProgramPartnerTypes?{payload}";
export const GET_SELLER_EXCLUSION_LIST_URL =
  "/scheme-planning/ims/getProgramSellerExclusionsList";
  export const GET_MARGIN_EXCLUSION_LIST_URL =
  "/scheme-planning/ims/getProgramMarginExclusionsList";
export const PARTNER_TYPE_FROM_LIST = "/scheme-planning/ims/fromPartnerTypes";
export const PARTNER_CODE_SELLER_EXCLUSION_LIST="/scheme-planning/ims/getSellerCodes?code={search}&dealerFlag={dealerFlag}"
export const PARTNER_TYPE_TO_LIST = "/scheme-planning/ims/toPartnerTypes";
export const PARTNER_TYPE_SAVE = "/scheme-planning/ims/saveProgramPartnerTypes";
export const SELLER_EXCLUSION_PARTNER_CODE_SAVE="/scheme-planning/ims/saveProgramSellerExclusions"
export const MARGIN_EXCLUSION_PARTNER_CODE_SAVE="/scheme-planning/ims/saveProgramMarginExclusions"
export const PARTNER_TYPE_DELETE =
  "/scheme-planning/ims/deleteProgramPartnerTypes";
  export const SELLER_EXCLUSION_PARTNER_CODE_DELETE="/scheme-planning/ims/deleteProgramSellerExclusions";
  export const MARGIN_EXCLUSION_PARTNER_CODE_DELETE="/scheme-planning/ims/deleteProgramMarginExclusions";

  export const SELLER_EXCLSION_PARTNER_CODE_IMPORT="/scheme-planning/ims/saveProgramSellerExclusions/import?{requestParams}"
  export const MARGIN_EXCLSION_PARTNER_CODE_IMPORT="/scheme-planning/ims/saveProgramMarginExclusions/import?{requestParams}"
  export const SELLER_EXCLUSION_PARTNER_CODE_EXPORT="/scheme-planning/ims/getProgramSellerExclusionsList/export"
  export const MARGIN_EXCLUSION_PARTNER_CODE_EXPORT="/scheme-planning/ims/getProgramMarginExclusionsList/export"
  export const SKU_CODE_SMART_SEARCH_URL =
  "/scheme-planning/ims/productgroup/search/skuCode?division={division}&skuCode={skuCode}";
  export const PLAN_LIST_DOWNLOAD = 
  "/scheme-planning/ims/schemePlanListExport?schemeRangeDate={startDate},{endDate}";
/** Scheme Exception*/
export const SCHEME_EXCEPTION_APPLY_FILTER =
  "/scheme-planning/ims/exception/allData?{payload}";
export const SCHEME_EXCEPTION_DROPDOWN_APPLY_ON =
  "/scheme-planning/ims/exception/dropdown?schemePrgHdrId={schemePrgHdrId}";
export const SCHEME_EXCEPTION_SAVE =
  "/scheme-planning/ims/exception/schemeException";
export const SCHEME_EXCEPTION_LIST =
  "/scheme-planning/ims/exception/getSchemeExceptions";
export const SCHEME_EXCEPTION_DELETE =
  "/scheme-planning/ims/exception/deleteListSchemeRef";

/** Scheme Reference*/
export const SCHEME_REFERENCE_ALL_PROGRAM_LIST =
  "/scheme-planning/ims/schemereference/schemesList{queryParams}";
export const SCHEME_REFERENCE_PAYOUT_LIST =
  "/scheme-planning/ims/schemereference/getPayouts?schemeRefId={schemeRefId}";
export const SCHEME_REFERENCE_SAVE =
  "/scheme-planning/ims/schemereference/add/references";
export const SCHEME_REFERENCE_EXISTING_LIST =
  "/scheme-planning/ims/schemereference/schemes?programId={programId}";
export const SCHEME_REFERENCE_EXISTING_PAYOUT_LIST =
  "/scheme-planning/ims/schemereference/payoutlines?schemeId={schemeId}&progrmId={programId}";
export const SCHEME_REFERENCE_EXISTING_DELETE =
  "/scheme-planning/ims/schemereference/delete/schemes?schemeRefId={schemeId}&programId={programId}";
export const SCHEME_REFERENCE_EXISTING_PAYOUT_DELETE =
  "/scheme-planning/ims/schemereference/deleteListSchemeRef";
export const EXECUTE_PLAN_PROGRAM_URL =
  "/scheme-planning/ims/schemePlan/execute";

/** Scheme Reference*/
export const SPECIFIC_MODAL_EXCEL_URL =
  "/scheme-planning/ims/productgroup/download/specificModelTemplate";
export const SPECIFIC_MODAL_ADD_URL =
  "/scheme-planning/ims/productgroup/specificModel/add";
export const SPECIFIC_MODAL_UPLOAD_URL =
  "/scheme-planning/ims/productgroup/upload/specificModel";
export const SPECIFIC_MODAL_VALIDATE_CODE_URL =
  "/scheme-planning/ims/productgroup/validate/specificModel?modelValues={productCode}";
export const SPECIFIC_MODAL_SMART_SEARCH_CODE_URL =
  "/scheme-planning/ims/productgroup/search/ProductCode?{search}";
export const PARTNER_SPECIFIC_MODAL_SMART_SEARCH_CODE_URL =
  "/scheme-planning/ims/search/partnercode/{search}";
export const SIMULATE_CALL_URL =
  "/scheme-planning/ims/productgroup/multipleProductCodes";
export const PARTNER_CODE_SMART_SEARCH_CODE_URL =
  "/scheme-planning/ims/partnercode/{search}";
export const PARTNER_ATTRIBUTE_CODE_SMART_SEARCH_CODE_URL =
  "/scheme-planning/ims/partnergroup/type/{payload}";
export const GET_OUTLET_MAPPING_OPTIONS_URL="/scheme-planning/ims/allOutletMapping?{requestParams}"
export const ADD_PROGRAM_EXPORT =
  "/scheme-planning/ims/export/programManualTemplate?programHdr={programHdr}";
export const UPLOAD_ADD_PROGRAM_URL =
  "/scheme-planning/ims/import/programManualUpload/{programHdr}";
export const GET_ADD_PROGRAM_MANUAL_UPLOAD_STATUS = 
  "/scheme-planning/ims/getStatus/programManualUpload?schemePlanNo={schemePlanNo}";
export const ADD_PROGRAM_MANUAL_UPLOAD_ERROR_FILE_DOWNLOAD = 
  "/scheme-planning/ims/errorFile/programManualUpload?programHdr={programHdr}&manualUploadHdrId={manualUploadHdrId}";
export const NERP_IS_READY_FOR_NERP = 
  "/scheme-planning/ims/nerp/enableNerp?programId={programId}&readyForNerp={readyForNerp}";
/**  Demo deduction */
export const GET_DEMO_DEDUCTION_DROPDOWN_OPTIONS_URL="/scheme-planning/ims/getMasterData";
export const GET_DEMO_DEDUCTION_URL="/scheme-planning/ims/getDemoDeductions";
export const SAVE_DEMO_DEDUCTION_URL="/scheme-planning/ims/saveDemoDeductions";
export const DEMO_DEDUCTION_DELETE_URL="/scheme-planning/ims/deleteDemoDeductions";

/** Release programs */
 export const RELEASE_PROGRAMS_URL="/scheme-planning/ims/schemePlan/release";
/**  Retail Visibility */
export const GET_RETAIL_VISIBILITY_URL="/scheme-planning/ims/getRetailVisibility";
export const SAVE_RETAIL_VISIBILITY_URL="/scheme-planning/ims/saveRetailVisibility";
export const DELETE_RETAIL_VISIBILITY_URL="/scheme-planning/ims/deleteRetailVisibility";
export const IMPORT_RETAIL_VISIBILITY_URL="/scheme-planning/ims/saveRetailVisibility/import?{requestParams}";
export const EXPORT_RETAIL_VISIBILITY_URL="/scheme-planning/ims/getRetailVisibilityList/export";
